import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useBooking } from '../context/BookingContext';

const Navbar = () => {
  const { openBooking } = useBooking();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { label: 'Services', path: '/services' },
    { label: 'About', path: '/about' },
    { label: 'Articles', path: '/articles' },
    { label: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md shadow-lg">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo on Left */}
          <Link to="/" className="flex-shrink-0" aria-label="Akira Signature Care home">
            <img
              src="/akira-logo.png"
              alt="Akira Signature Care"
              className="h-14 w-auto"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </Link>

          {/* Desktop Menu on Right */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                className={`text-sm tracking-widest uppercase font-light transition-colors duration-300 hover:text-rose-400 ${
                  isActive(link.path) ? 'text-rose-400' : 'text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
            
            <button
              onClick={() => openBooking()}
              className="bg-rose-400 hover:bg-rose-500 text-white px-6 py-2 rounded-full text-sm font-semibold tracking-wider transition-colors"
            >
              BOOK NOW
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="lg:hidden text-white hover:text-rose-400 transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileOpen && (
        <div className="lg:hidden bg-white border-t border-stone-200">
          <div className="px-6 py-8 space-y-6">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                onClick={() => setIsMobileOpen(false)}
                className={`block text-xl font-light transition-colors ${
                  isActive(link.path) ? 'text-rose-400' : 'text-stone-800 hover:text-rose-400'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <button
              onClick={() => {
                openBooking();
                setIsMobileOpen(false);
              }}
              className="w-full bg-rose-400 hover:bg-rose-500 text-white py-3 rounded-full font-semibold"
            >
              BOOK NOW
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
